<div class="consignee-partial-container container">
  <div>
    <h1>Получатель</h1>

    <div class="wrapperPersonTypeInn">
      <el-form-item prop="consignee.consigneeType">
        <el-switch
          :disabled="dataForm.thirdPerson.cargoTransportationCustomer === 'Получатель'"
          @change="handleChangeTypeOfPerson('Получатель', $event)"
          v-model="dataForm.consignee.consigneeType"
          inactive-text="Физ.лицо"
          active-text="Юр.лицо"
        />
      </el-form-item>
      <el-form-item style="flex: 1; width: 100%" v-if="dataForm.consignee.consigneeType" label="ИНН получателя" prop="consignee.innConsignee">
        <InnAutocomplete
          :disabledCustom="dataForm.thirdPerson.cargoTransportationCustomer === 'Получатель'"
          v-model:inn="dataForm.consignee.innConsignee"
          @setOrganization="dataForm.consignee.name = $event"
        />
      </el-form-item>
    </div>

    <el-form-item v-if="dataForm.consignee.consigneeType" label="Наименование организации" prop="consignee.name">
      <OrganizationAutocomplete
        :disabledCustom="dataForm.thirdPerson.cargoTransportationCustomer === 'Получатель'"
        v-model:organization="dataForm.consignee.name"
        @setInn="dataForm.consignee.innConsignee = $event"
      />
    </el-form-item>

    <el-form-item class="personContactInfo">
      <el-form-item label="Телефон получателя" prop="consignee.phoneConsignee">
        <el-input
          :disabled="dataForm.thirdPerson.cargoTransportationCustomer === 'Получатель'"
          v-model="dataForm.consignee.phoneConsignee"
          v-mask="PHONE_MASK"
          type="tel"
          :formatter="(value) => `${value}`.replace(/\(89/g, '9')"
          :placeholder="PHONE_PLACEHOLDER"
          @change="checkPhone"
        />
      </el-form-item>

      <el-form-item type="email" label="Эл. почта" prop="consignee.emailConsignee">
        <!-- prop="consignee.emailConsignee" -->
        <!-- :required="dataForm.consignee.consigneeType" -->
        <el-input :disabled="dataForm.thirdPerson.cargoTransportationCustomer === 'Получатель'" type="email" autocomplete="email" v-model="dataForm.consignee.emailConsignee" />
      </el-form-item>
    </el-form-item>

    <el-form-item label="ФИО получателя" v-if="!dataForm.consignee.consigneeType" class="personFio" prop="consignee.fioConsignee">
      <FIOAutocomplete
        :disabled="dataForm.thirdPerson.cargoTransportationCustomer === 'Получатель'"
        :onChangeSideEffect="() => ruleFormRef.validateField(['consignee.fioConsignee'])"
        :disabledCustom="dataForm.thirdPerson.cargoTransportationCustomer === 'Получатель'"
        v-model:fio="dataForm.consignee.fioConsignee"
      />
    </el-form-item>

    <el-form-item label="Город получения" prop="consignee.cityTo">
      <el-select
        value-key="id"
        style="width: 100%"
        v-model="dataForm.consignee.cityTo"
        placeholder="Выберите город"
        filterable
        v-cancel-read-only
        autocomplete="do-not-autofill"
        @change="handlerCityTo"
      >
        <el-option v-for="city in cities" :key="city.id" :label="city.title" :value="city" :disabled="disableIdenticalCity(city)" />
      </el-select>
    </el-form-item>

    <el-form-item prop="consignee.consigneeDeliveryType">
      <el-radio-group :disabled="disabledDeliveryType" @change="handleConsigneeDelivery" class="radioGroupButtonsDefault" v-model="dataForm.consignee.consigneeDeliveryType">
        <el-radio-button label="Доставка до адреса" value="Доставка до адреса" />
        <el-radio-button :disabled="dataForm.fetchedSuitableOffices.delivery.length === 0" label="Забрать на складе" value="Забрать на складе" />
      </el-radio-group>
    </el-form-item>

    <el-form-item style="flex: 1" :label="dataForm.consignee.consigneeDeliveryType === 'Забрать на складе' ? 'Адрес склада' : 'Адрес доставки груза'" prop="consignee.addressCargoDelivery">
      <el-select
        value-key="id"
        :disabled="disabledDeliveryType"
        filterable
        v-cancel-read-only
        autocomplete="do-not-autofill"
        v-if="dataForm.consignee.consigneeDeliveryType !== 'Доставка до адреса'"
        style="width: 100%"
        v-model="dataForm.consignee.addressCargoDelivery"
        readonly
      >
        <el-option v-for="office in dataForm.fetchedSuitableOffices.delivery" :key="office.id" :label="office.address" :value="office" />
      </el-select>

      <el-input
        :disabled="disabledDeliveryType"
        class="addressClick"
        @click="onClickAddressDelivery"
        v-if="dataForm.consignee.consigneeDeliveryType !== 'Забрать на складе' && dataForm.consignee.consigneeDeliveryType !== ''"
        readonly
        :model-value="consigneeDeliveryFullAddress"
      />
    </el-form-item>

    <ConsigneeInfoDeliveryForm v-model:isOpen="isOpeModalCargoDelivery" />
  </div>

  <!-- <div class="bord_button">
    <el-form-item>
      <el-button
        class="button_send"
        type="primary"
        @click="$emit('click-button-back')"
      >
        Назад
      </el-button>
    </el-form-item>
    <el-form-item>
      <el-button
        class="button_send"
        type="primary"
        @click="$emit('click-button-next')"
      >
        Далее
      </el-button>
    </el-form-item>
  </div> -->
</div>
